export const getCampaignAdgroupMultiSelectorStyle = (iconFontFamily = 'MsAds MDL2 Assets') => ({
  '& .ba-campaign-selector .list-selector-content .add-arrow-button': {
    top: '20%',
  },
  '& .ba-campaign-adgroup-selector .list-selector-content .add-arrow-button': {
    top: '50%',
  },
  '& .ba-campaign-selector, .ba-campaign-adgroup-selector': {
    top: 'auto',
    left: 'auto',
    '& .list-selector-content .remove-arrow-button': {
      position: 'absolute',
      top: '2%',
      right: 10,
    },
    '& .list-selector-content .add-arrow-button': {
      position: 'absolute',
      right: 10,
    },
    '& .ba-entity-selector': {
      minWidth: 300,
    },
    '& .dropdown-toggle': {
      width: '220px !important',
    },
    '& .multi-selector': {
      border: 'none',
      '& .ba-pagination': {
        '& .pager-input': {
          width: '70px',
        },
      },
      '& .ba-list-selector': {
        borderTop: '0px', // we want to have a light grey line for the bottom border of the search box
        '& .list-selector-action-bar': {
          '& [class*="-all-content"]': {
            padding: '10px 8px',
            color: '#0078D4',
            cursor: 'pointer',
            '& span': {
              '&:hover': {
                color: '#004578',
                textDecorationLine: 'underline',
              },
            },
          },
          '& .select-all-content .enabled.arrow-button': {
            float: 'right',
          },
          '& .remove-all-content .remove.arrow-button': {
            marginTop: 0,
          },
        },
        '& .list-selector-content': {
          '& .list-selector-item': {
            maxWidth: '350px',
            '& .statusEnabled_icon::before': { // Todo: find icons for status disabled etc.
              color: '#107c10',
              content: '"\\ECCC"',
              fontFamily: iconFontFamily,
            },
            '& .statusPaused_icon::before': { // Todo: find icons for status disabled etc.
              color: '#323130',
              content: '"\\F6B0"',
              fontFamily: iconFontFamily,
            },
            '& .statusDeleted_icon::before': { // Todo: find icons for status disabled etc.
              color: '#FF0000',
              content: '"\\E738"',
              fontFamily: iconFontFamily,
            },
            '& .iconba-Error': {
              color: '#d13438',
            },
            '& .iconba-Completed': {
              color: '#107c10',
            },
            '& > div, & .item-content': {
              maxWidth: 'none !important',
            },
          },
        },
        '& .arrow-button': {
          color: '#0078D4',
        },
        '& .arrow-button.enabled': {
          marginLeft: 10,
          overflow: 'visible !important',
          textDecoration: 'none !important',
          background: 'none !important',
          fontFamily: iconFontFamily,
          cursor: 'pointer',
        },

        '& .arrow-button.enabled:before': {
          content: '"\\E710"',
        },

        '& .arrow-button.remove': {
          marginRight: 10,
          marginTop: 8,
          float: 'right',
          fontFamily: iconFontFamily,
          padding: 0,
          cursor: 'pointer',
        },

        '& .arrow-button.remove:before': {
          content: '"\\E738"',
        },

        '& .arrow-button.remove+a': {
          width: 'fit-content',
          padding: 0,
        },
        '& .btn-done': {
          marginRight: '10px',
        },
      },
      '& .multi-selector-result-container': {
        margin: '0 0 0 8px',
        '& .list-selector-container .ba-list-selector': {
          height: '351px',
          borderTop: '1px solid #605E5C', // no search box on top of the result container
        },
      },
    },
  },
});
